
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  grid = {};
  url = "/api/supervisor/grid?rows=20";
  passwordModal = false;
  showFilter = false;
  name = "";
  menu1 = false;
  filterUrl = "";
  email = "";
  capcheImg = "";
  role = "";
  showConfirmDelete = false;
  deleteConfirmed = false;
  toDeleteCampus = null;
  page = 1;
  changePasswordObj = {
    _id: "",
    name: "",
  };
  selectedSuperv = {
    _id: "",
    name: "",
  };
  on = false;

  get loading() {
    return common.loading;
  }

  async changesPass(superv) {
    try {
      if (superv != undefined) {
        this.selectedSuperv = superv;
      }
      this.passwordModal = true;
      const currentTimeStamp = new Date().getTime();
      this.capcheImg = "/api/o/captcha/supervisor?id=" + currentTimeStamp;
    } catch (e) {
      console.log(e);
    }
  }
  async changesPassApi() {
    try {
      this.changePasswordObj._id = this.selectedSuperv._id;
      this.changePasswordObj.name = this.selectedSuperv.name;
      await doPost("/api/supervisor/resetPassword", this.changePasswordObj);
      common.showMessage("Saved Successfully");
      this.passwordModal = false;
      this.modalReset();
    } catch (e) {
      console.log(e);
      common.setError(e.message);
    }
  }

  modalReset() {
    this.selectedSuperv = this.changePasswordObj = {
      _id: "",
      name: "",
    };
    this.passwordModal = false;
  }

  async makeSuperAdmin(superv) {
    try {
      await doGet("/api/supervisor/" + superv._id + "/makeSuperAdmin");
      common.showMessage("Successfully save");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async deleteSuperVisor(superv) {
    common.setLoading(true);
    try {
      await doGet("/api/supervisor/" + superv._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.name = "";
    this.email = "";
    this.role = "";
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.name) this.filterUrl += "&name=" + this.name;
    if (this.email) this.filterUrl += "&email=" + this.email;
    if (this.role) this.filterUrl += "&role=" + this.role;
    common.setLoading(true);
    await this.showPage(1);
  }
}
